import React, { Context, createContext, PropsWithChildren, useCallback, useContext, useState } from 'react'
import { IModals, TModalsActions } from '../types'

/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */

const initialModalsState: IModals = {}

const ModalContext: Context<{
	modals: IModals
	actions: TModalsActions
}> = createContext({
	modals: initialModalsState,
	actions: {
		// tslint:disable-next-line: no-empty
		open: (modal: string) => {},
		// tslint:disable-next-line: no-empty
		close: (modal: string) => {},
		// tslint:disable-next-line: no-empty
		toggle: (modal: string) => {},
	},
})

export const ModalProvider = (props: PropsWithChildren<{}>) => {
	const [modals, setModal] = useState<IModals>({})

	const open = useCallback(
		(modal: string, id?: number) =>
			setModal({
				...modals,
				[modal]: {
					open: true,
					id,
				},
			}),
		[modals]
	)
	const close = useCallback(
		(modal: string) =>
			setModal({
				...modals,
				[modal]: {
					open: false,
				},
			}),
		[modals]
	)
	const toggle = useCallback(
		(modal: string, id?: number) =>
			setModal({
				...modals,
				[modal]: {
					open: !modals[modal] || !modals[modal].open,
					id,
				},
			}),
		[modals]
	)

	const actions: TModalsActions = { open, close, toggle }

	return <ModalContext.Provider value={{ modals, actions }}>{props.children}</ModalContext.Provider>
}

export const useModalsContext: () => {
	modals: IModals
	actions: TModalsActions
} = () => {
	return useContext(ModalContext)
}
